<template>
  <div class="duplicate-entry-dialog">
    <el-dialog custom-class="with-title small" :title="title" :visible.sync="visible" :show-close="true">
      <div class="dialog-content">
        <div class="duplicate-entry-block mb-x2" v-for="(entry, index) in duplicateEntries" :key="entry.id">
          <div class="duplicate-entry-datetime" layout layout-align="start-center">
            <el-tooltip v-if="entry.postType === 'mention'" placement="top" content="メンション"
              ><img class="icon mr-x1" src="@/client/assets/images/icon_mention.svg"
            /></el-tooltip>
            <el-tooltip v-if="entry.postType === 'retweet'" placement="top" content="リポスト"
              ><img class="icon mr-x1" src="@/client/assets/images/icon_retweet.svg"
            /></el-tooltip>
            <el-tooltip v-if="entry.postType === 'quote_tweet'" placement="top" content="引用"
              ><img class="icon mr-x1" src="@/client/assets/images/icon_quote_tweet.svg" /></el-tooltip
            ><span class="text-sub-color">{{ formatDatetime(entry.publishDatetime) }}</span>
          </div>
          <TwitterPostEmbed :id="entry.id"></TwitterPostEmbed>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script lang="ts">
// @ts-nocheck TODO: 既存の型エラーを解消したら外す
import { defineComponent } from 'vue'

import TwitterPostEmbed from '@/client/components/_atoms/twitter_post_embed'
import { formatDatetime } from '@/client/filters/filters'

type TDuplicateEntry = {
  id: number
  postType: string
  publishDatetime: string
}

export default defineComponent({
  data() {
    return {
      title: '',
      visible: false,
      duplicateEntries: []
    }
  },
  components: {
    TwitterPostEmbed
  },
  methods: {
    formatDatetime,

    open(accountName: string, duplicateEntries: TDuplicateEntry[]) {
      this.title = `${accountName} さんの重複応募詳細(${duplicateEntries.length}件)`
      this.duplicateEntries = duplicateEntries
      this.visible = true
    },

    close() {
      this.title = ''
      this.duplicateEntries = []
      this.visible = false
    }
  }
})
</script>
